import axios from "axios";
import * as Config from "../../Utils/Config";


export async function UpdateConfigSettingsdata(data) {
    try {
        const res = await axios.post(`${Config.base_url}updateConfigSetting`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}



export async function GetConfigSettingsdata(data) {
    try {
        const res = await axios.post(`${Config.base_url}getConfigSetting`, data, {
            data: {},
        })
        return await res?.data;
    }
    catch (err) {
        return await err;
    }
}
